import type { Locale } from '../i18n/LocaleContext'

export interface RouteDefinition {
  path: string
  labelKey: 'home' | 'camps' | 'about' | 'activities' | 'contact'
}

export const navRoutes: Record<Locale, RouteDefinition[]> = {
  hu: [
    { path: '/hu', labelKey: 'home' },
    { path: '/hu/taborok', labelKey: 'camps' },
    { path: '/hu/tevekenysegek', labelKey: 'activities' },
    { path: '/hu/rolunk', labelKey: 'about' },
    { path: '/hu/kapcsolat', labelKey: 'contact' },
  ],
  ro: [
    { path: '/ro', labelKey: 'home' },
    { path: '/ro/tabere', labelKey: 'camps' },
    { path: '/ro/activitati', labelKey: 'activities' },
    { path: '/ro/despre', labelKey: 'about' },
    { path: '/ro/contact', labelKey: 'contact' },
  ],
}

export function getCampsPath(locale: Locale): string {
  return locale === 'hu' ? '/hu/taborok' : '/ro/tabere'
}

// FAQ page is intentionally NOT in navRoutes (not in the menu); it's linked
// from the footer and the FAQ sections on the homepage / contact page.
export function getFaqPath(locale: Locale): string {
  return locale === 'hu' ? '/hu/gyik' : '/ro/intrebari-frecvente'
}

export function getCampPath(locale: Locale, slug: string): string {
  return `${getCampsPath(locale)}/${slug}`
}

export function getContactPath(locale: Locale): string {
  return locale === 'hu' ? '/hu/kapcsolat' : '/ro/contact'
}

export function getActivitiesPath(locale: Locale): string {
  return locale === 'hu' ? '/hu/tevekenysegek' : '/ro/activitati'
}

export function getHomePath(locale: Locale): string {
  return `/${locale}`
}

export function getAboutPath(locale: Locale): string {
  return locale === 'hu' ? '/hu/rolunk' : '/ro/despre'
}

export function getTermsPath(locale: Locale): string {
  return locale === 'hu' ? '/hu/feltetelek' : '/ro/termeni'
}

export function getPrivacyPath(locale: Locale): string {
  return locale === 'hu' ? '/hu/adatvedelem' : '/ro/confidentialitate'
}

// "Livrare" / "Retur/Anulare" — required on the site for RO card-payment
// merchant verification. Not in the nav; linked from the footer and the Terms.
export function getDeliveryPath(locale: Locale): string {
  return locale === 'hu' ? '/hu/teljesites' : '/ro/livrare'
}

export function getRefundsPath(locale: Locale): string {
  return locale === 'hu' ? '/hu/lemondas' : '/ro/retur-anulare'
}

export function getCookiePath(locale: Locale): string {
  return locale === 'hu' ? '/hu/cookie-szabalyzat' : '/ro/politica-cookies'
}

export function getRegistrationPath(locale: Locale): string {
  return locale === 'hu' ? '/hu/beiratkozas' : '/ro/inscriere'
}

export function getPaymentResultPath(locale: Locale): string {
  return locale === 'hu' ? '/hu/fizetes-eredmeny' : '/ro/rezultat-plata'
}
